<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Create Project"
        @close="$emit('close')"
    >
        <template #icon>
            <zen-icon-create />
        </template>
        <template #body>
            <div class="space-y-1 mb-6">
                <p class="text-sm text-taupe-600">
                    Please enter the name of your project. A unique key will be
                    automatically generated.
                </p>
            </div>

            <div class="space-y-5">
                <div>
                    <label
                        for="input-project-name"
                        class="block text-sm font-medium leading-6 text-taupe-900"
                    >
                        Project name
                        <span class="text-red-500">*</span>
                    </label>
                    <div class="mt-2">
                        <input
                            id="input-project-name"
                            :value="name"
                            @input="$emit('update:name', $event.target.value)"
                            type="text"
                            name="input-project-name"
                            placeholder="My Project"
                            class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 transition-shadow"
                        />
                    </div>
                    <p v-if="name" class="mt-1.5 text-xs text-taupe-500">
                        Project key will be:
                        <span class="font-medium font-mono">{{
                            stringToKey(name)
                        }}</span>
                    </p>
                </div>
            </div>
        </template>
        <template #buttons>
            <zen-button @click="$emit('close')" variant="secondary">
                Close
            </zen-button>
            <zen-button
                @click="$emit('confirm')"
                variant="primary"
                :processing="processing"
            >
                Create
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script setup>
import stringToKey from '@/helpers/string-to-key'

defineProps({
    isOpen: {
        type: Boolean,
        required: true,
    },
    name: {
        type: String,
        default: '',
    },
    processing: {
        type: Boolean,
        default: false,
    },
})

defineEmits(['close', 'confirm', 'update:name'])
</script>
